/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Events } from './Events';
var TrackerState;
(function (TrackerState) {
    TrackerState[TrackerState["IDLE"] = 0] = "IDLE";
    TrackerState[TrackerState["FIRST"] = 1] = "FIRST";
    TrackerState[TrackerState["NEXT"] = 2] = "NEXT";
    TrackerState[TrackerState["FINISH"] = 3] = "FINISH";
    TrackerState[TrackerState["CANCEL"] = 4] = "CANCEL";
})(TrackerState || (TrackerState = {}));
/**
 * Mouse arrow Tracking
 */
export class Tracker {
    constructor(stage) {
        this._state = TrackerState.IDLE;
        this._onMove = (_x, _y) => { }; // tslint:disable-line
        this._onFirstClick = (_intersec) => { }; // tslint:disable-line
        this._onNextClick = (_intersec) => { }; // tslint:disable-line
        this._onCancel = () => { }; // tslint:disable-line
        this._onClickAfterFinish = () => { }; // tslint:disable-line
        this._stage = stage;
        this._canvas = stage.getRenderer().domElement;
        this._canvas.addEventListener('mousemove', this._onMouseMove.bind(this));
        this._stage.addEventListener(Events.OBJECTCLICKED, this._onObjectClicked.bind(this));
    }
    onMove(func) {
        this._onMove = func;
    }
    onFirstClick(func) {
        this._onFirstClick = func;
    }
    onNextClick(func) {
        this._onNextClick = func;
    }
    onClickAfterFinish(func) {
        this._onClickAfterFinish = func;
    }
    onCancel(func) {
        this._onCancel = func;
    }
    start() {
        this._state = TrackerState.FIRST;
    }
    finish() {
        this._state = TrackerState.FINISH;
    }
    deactivate() {
        this._state = TrackerState.IDLE;
    }
    _handleClick(intersection) {
        switch (this._state) {
            case TrackerState.FIRST:
                this._onFirstClick(intersection);
                this._state = TrackerState.NEXT;
                break;
            case TrackerState.NEXT:
                this._onNextClick(intersection);
                break;
            case TrackerState.FINISH:
                this._onClickAfterFinish();
                break;
            case TrackerState.IDLE:
            default:
                break;
        }
    }
    _onObjectClicked(event) {
        if (event.detail.button === 0 && !!event.detail.new) {
            this._handleClick(event.detail.new);
        }
        else if (event.detail.button === 2) {
            this._onCancel();
            this._state = TrackerState.FIRST;
        }
    }
    _onMouseMove(event) {
        if (this._state === TrackerState.NEXT) {
            const elem = this._canvas.getBoundingClientRect();
            const mousex = ((event.clientX - elem.left) / (elem.width)) * 2 - 1;
            const mousey = -((event.clientY - elem.top) / (elem.height)) * 2 + 1;
            this._onMove(mousex, mousey);
        }
    }
}
//# sourceMappingURL=Tracker.js.map